import { Group, Paper, Switch, UnlabeledField } from '@common/ui'
import TrimmedTextInput from './TrimmedTextInput'
import { com } from '@eidu/web'
import Checkbox = com.eidu.sharedlib.form.definition.Checkbox
import { withKey } from '../../util/withKey'
import FormKeyField from './FormKeyField'

type CheckboxItemProps = {
  item: Checkbox
  onChange?: (newItem: Checkbox) => void
}

const CheckboxItem: React.FC<CheckboxItemProps> = ({ item, onChange }) => (
  <Paper withBorder radius="sm" p="xs">
    <Group gap="md" wrap="nowrap" align="flex-start">
      <TrimmedTextInput
        style={{ flex: 1 }}
        value={item.prompt}
        onChange={(e) => onChange?.(withKey(item.copy(e.target.value, item.key), item))}
        placeholder="Enter prompt"
        label="Prompt"
        disabled={!onChange}
      />
      <FormKeyField
        value={item.key}
        onChange={(e) => onChange?.(withKey(item.copy(item.prompt, e.target.value), item))}
        label="Key"
        disabled={!onChange}
      />
      <UnlabeledField>
        <Switch
          checked={item.required}
          onChange={(e) => onChange?.(withKey(item.copy(item.prompt, item.key, e.target.checked), item))}
          disabled={!onChange}
          label="Required"
        />
      </UnlabeledField>
    </Group>
  </Paper>
)

export default CheckboxItem
